import * as z from "zod"

// Helper schema for JSON fields
type Literal = boolean | number | string
type Json = Literal | { [key: string]: Json } | Json[]
const literalSchema = z.union([z.string(), z.number(), z.boolean()])
const jsonSchema: z.ZodSchema<Json> = z.lazy(() => z.union([literalSchema, z.array(jsonSchema), z.record(jsonSchema)]))

export const AirportModel = z.object({
  id: z.string(),
  created_at: z.date(),
  updated_at: z.date(),
  name: z.string().nullish(),
  latlng: z.number().array(),
  time_zone: z.string(),
  /**
   * [Address]
   */
  address: jsonSchema,
  country: z.string().nullish(),
  can_depart: z.boolean(),
  can_arrive: z.boolean(),
})
